export default __webpack_public_path__ + "static/media/sidebar8.fb8c23d1.jpg";